import { render, staticRenderFns } from "./SortableField.vue?vue&type=template&id=4ec03a8c&"
import script from "./SortableField.vue?vue&type=script&lang=js&"
export * from "./SortableField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports